import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { routeComponentMap } from '../../appConstants';

export const useContextMetadata = () => {
  const location = useLocation();
  const getContextMeta = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get('tab') ?? 'default'; // fallback for tab

    const component = routeComponentMap.get(location.pathname);
    if (!component) {
      throw new Error(`No component mapped for route ${location.pathname}`);
    }

    return {
      component,
      tab,
      route: location.pathname,
    };
  }, [location]);

  return getContextMeta;
};
